/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React, { PropTypes, Component } from 'react';
import styles from './StepPage.css';
import withStyles from '../../decorators/withStyles';

import Steps from '../Steps';

@withStyles(styles)
class StepPage extends Component {

  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    content: PropTypes.object,
    steps: PropTypes.object,
    step: PropTypes.number
  };

  static contextTypes = {
    onSetTitle: PropTypes.func.isRequired,
    onSetMeta: PropTypes.func.isRequired
  };

  render() {
    this.context.onSetTitle(this.props.title);
    this.context.onSetMeta('description', this.props.description);

    return (
      <div className="StepPage">
        <Steps step={this.props.step}/>
        {this.props.content && React.cloneElement(this.props.content, { steps: this.props.steps })}
      </div>
    );
  }

}

export default StepPage;



/** WEBPACK FOOTER **
 ** ./src/components/StepPage/StepPage.js
 **/